// extracted by mini-css-extract-plugin
module.exports = {"uk-pc-newcomer-gift":"style_uk-pc-newcomer-gift__FeSIb","closeBtn":"style_closeBtn__ztfav","icon":"style_icon__Zx3sT","text":"style_text__ZApx3"};